import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5246a1ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "detailQuestionView" }

import { MyAxios } from "@/plugins/axios";
import { useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import message from "@arco-design/web-vue/es/message";
import CodeEditor from "@/components/CodeEditor.vue";
import MDViewer from "@/components/MDViewer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailQuestionView',
  setup(__props) {

const route = useRoute();
const data = ref({});
const submitParams = ref({
  questionId: route.query.id,
  language: "java",
  code: "",
});
const loadData = async () => {
  await MyAxios.get("/question/get/vo?id=" + route.query.id).then((res) => {
    if (res.data.code === 0) {
      data.value = res.data.data;
      // console.log(data.value);
    } else {
      message.error("加载失败：" + res.data.message);
    }
  });
};
onMounted(() => {
  loadData();
});
const codeChange = (code: string) => {
  submitParams.value = {
    ...submitParams.value,
    code: code,
  };
};
const languageChange = (language: string) => {
  submitParams.value = {
    ...submitParams.value,
    language: language,
  };
};
const doSubmit = () => {
  MyAxios.post("/question/question_submit/do", submitParams.value).then(
    (res) => {
      if (res.data.code === 0) {
        message.success("提交成功，判题中......");
      } else {
        message.error("提交失败: " + res.data.message);
      }
    }
  );
};

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          md: 12,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, { "default-active-key": "1" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  title: "题目"
                }, {
                  default: _withCtx(() => [
                    (data.value)
                      ? (_openBlock(), _createBlock(_component_a_card, {
                          key: 0,
                          title: data.value.title
                        }, {
                          extra: _withCtx(() => [
                            _createVNode(_component_a_space, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.tags, (tag, index) => {
                                  return (_openBlock(), _createBlock(_component_a_tag, {
                                    color: "#7bc616",
                                    key: index
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(tag), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_a_descriptions, {
                              title: "判题信息",
                              column: { xs: 1, md: 2, lg: 3 },
                              layout: "inline-horizontal"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_descriptions_item, { label: "时间限制" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(data.value?.judgeConfig?.timeLimit ?? 0) + " ms", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_descriptions_item, { label: "内存限制" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(data.value?.judgeConfig?.memoryLimit ?? 0) + " kb", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_descriptions_item, { label: "堆栈限制" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_tag, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(data.value?.judgeConfig?.stackLimit ?? 0) + " kb", 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(MDViewer, {
                              value: data.value.content || ''
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        }, 8, ["title"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "2",
                  title: "题解"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_card, null, {
                      default: _withCtx(() => [
                        _createVNode(MDViewer, {
                          value: data.value.answer || ''
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          md: 12,
          xs: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_select, {
              style: {"width":"160px","margin-bottom":"7px"},
              "trigger-props": { autoFitPopupMinWidth: true },
              modelValue: submitParams.value.language,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((submitParams.value.language) = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("java")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("cpp")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_option, null, {
                  default: _withCtx(() => [
                    _createTextVNode("python")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(CodeEditor, {
              language: submitParams.value.language,
              "handle-change": codeChange
            }, null, 8, ["language"]),
            _createVNode(_component_a_button, {
              type: "primary",
              style: {"margin-top":"20px"},
              onClick: doSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交代码 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})